import React from 'react';
import { Clock } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-14 px-4 relative" data-id="element-111">
      <div className="max-w-3xl mx-auto text-center" data-id="element-112">
        <FadeIn data-id="element-113">
          <div className="flex justify-center mb-5" data-id="element-114">
            <Clock className="w-8 h-8 text-lavender-400 opacity-80" strokeWidth={1.5} data-id="element-115" />
          </div>

          <p className="text-xl md:text-2xl font-heading italic text-warmWhite-100 leading-relaxed mb-5" data-id="element-116">
            "Son las 3:14 de la mañana. Estás mirando el techo, sintiendo ese
            calor repentino y el latido acelerado de tu corazón. Tu mente ya
            empezó a repasar la lista de pendientes de mañana, y mientras más
            intentas dormir, más despierta te sientes."
          </p>

          <p className="text-lg text-warmWhite-200 leading-relaxed" data-id="element-117">
            Sabes que mañana estarás irritable, con la mente nublada y
            recurriendo a la tercera taza de café solo para sobrevivir al día.{' '}
            <span className="text-gold-400 font-medium" data-id="element-118">
              No tiene por qué ser así.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}